import styled from 'styled-components';
import colors from './colors';

export const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 1rem 2.5rem;
  box-sizing: border-box;
  background: ${colors.background.default};
  border: 1px solid ${colors.neutral.grey300};
  border-radius: 2px;
`;
